import { SuiteManifest } from '../manifest';
import { helpdeskRoutes } from './routes';

export const helpdeskManifest: SuiteManifest = {
  id: 'helpdesk',
  name: 'Helpdesk & Support',
  basePath: '/helpdesk',
  icon: 'help-circle',
  description: 'Customer ticket management, SLA tracking, and support automation.',
  requiredPermission: 'helpdesk.ticket.read',
  nav: [
    { label: 'Tickets', path: '/helpdesk/tickets', icon: 'inbox', permission: 'helpdesk.ticket.read', group: 'Support', status: 'live' },
    { label: 'Knowledge Base', path: '/helpdesk/kb', icon: 'file-text', permission: 'helpdesk.article.read', group: 'Knowledge', status: 'planned' },
  ],
  routes: helpdeskRoutes,
};

export default helpdeskManifest;
